"use client";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import { useContext } from "react";

import { Layout } from "@portal/app/_components/ui-elements/Layout";
import { PageContext } from "@portal/app/_components/context/PageContext";

/**
 * Simple 404 page for when context isn't available (e.g., Payload CMS routes)
 */
const SimpleNotFound = () => (
  <div style={{ padding: "2rem", textAlign: "center", fontFamily: "system-ui, sans-serif" }}>
    <h1>This page wasn&apos;t found.</h1>
    <p>
      If you followed a link, it might have been to a page that moved or doesn&apos;t exist
      anymore. Sorry about that!
    </p>
    <a href={process.env.DREAM_PORTAL_URL || "/"} style={{ color: "#0070f3", textDecoration: "underline" }}>
      Back to home page
    </a>
  </div>
);

export const NotFoundPage = () => {
  // Check if PageContext is available - if not, render simple version
  // This handles cases like Payload CMS routes where context providers aren't mounted
  const pageContext = useContext(PageContext);

  if (!pageContext) {
    return <SimpleNotFound />;
  }

  return (
    <Layout footer="BOTH" nav={null}>
      <Content data-testid="not-found-page">
        <h1>This page wasn&apos;t found.</h1>
        <p>
          If you followed a link, it might have been to a page that moved or doesn&apos;t exist
          anymore. Sorry about that!
        </p>
        {/* Do not update this. Because our homepage is deployed in Webflow, it needs
          to use an anchor tag instead of a Next Link. */}
        <a href={process.env.DREAM_PORTAL_URL}>
          <Button>Back to home page</Button>
        </a>
      </Content>
    </Layout>
  );
};

const Content = styled(Box)`
  max-width: var(--horizontal-maxWidth);
  margin: 0 auto;
  padding: var(--horizontal-padding);
`;
